import React from 'react';

var currentTime = new Date()
var year = currentTime.getFullYear()  
 

export default function Footer() {
  return (
    <footer className="bg-black small text-center text-white-50">
      <div className="container">
       &copy; {year} Hyper Dynamo LLC  
      </div>
    </footer>
  );
}
